// In-tab public dog profile. Reuses the same component as the root /dog/[id]
// route, but lives INSIDE the Dogs tab so navigating here from the Followers
// page (and back) stays within the Dogs stack — no tab-group crossing, so the
// back-pop is reliable and the Dogs tab never gets stuck. Reached via
// router.push(`/(tabs)/dogs/dogview/<slug>?backTo=followers&...`).
export { default } from "../../../dog/[id]";
